import { render, staticRenderFns } from "./AskBuyAfter.vue?vue&type=template&id=f9dcd286&"
import script from "./AskBuyAfter.vue?vue&type=script&lang=ts&"
export * from "./AskBuyAfter.vue?vue&type=script&lang=ts&"
import style0 from "./AskBuyAfter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports